module.exports = __webpack_public_path__ + "img/logo.d437fa18.png";